import { Injectable } from '@angular/core';
import { mapFetchResultData } from '@x/common/graph';
import {
  IShopSubscription,
  IShopSubscriptionQuery,
  IShopSubscriptionsQuery,
} from '@x/ecommerce/shop-client';
import { Observable } from 'rxjs';
import {
  ShopSubscriptionGQL,
  ShopSubscriptionsGQL,
  ShopSubscriptionTermsUrlGQL,
} from './gql/shop-subscriptions.gql.generated';

@Injectable()
export class ShopSubscriptionService {
  constructor(
    private shopSubscriptionsGQL: ShopSubscriptionsGQL,
    private shopSubscriptionGQL: ShopSubscriptionGQL,
    private shopSubscriptionTermsUrlGQL: ShopSubscriptionTermsUrlGQL,
  ) {}

  fetchSubscriptions(query: IShopSubscriptionsQuery): Observable<IShopSubscription[]> {
    return this.shopSubscriptionsGQL
      .fetch(query)
      .pipe(mapFetchResultData((r) => r.shopSubscriptions));
  }

  fetchSubscriptionById(query: IShopSubscriptionQuery): Observable<IShopSubscription> {
    return this.shopSubscriptionGQL
      .fetch(query)
      .pipe(mapFetchResultData((r) => r.shopSubscription));
  }

  fetchSubscriptionTermsUrl(query: IShopSubscriptionQuery): Observable<string | undefined | null> {
    return this.shopSubscriptionTermsUrlGQL
      .fetch(query)
      .pipe(mapFetchResultData((r) => r.shopSubscription.termsUrl));
  }
}
